import { getColumns as getReceiptColumns } from "../../ReceiptPage/components/ReceiptLookupTable/columns"
import ResultTag from "./ResultTag"
import { sortableTitle } from "./sortableTitle"

export const RESULT_OPTIONS = [
  { id: "matched", name: "Matched" },
  { id: "not_matched", name: "Not matched" },
  { id: "failed", name: "Failed" }
]

// The short values that read wrong broken over two lines ("••••309" / "5").
const NO_WRAP = new Set(["card", "result", "amount", "fee_charged"])

// Lookup activity's columns (RCA-12-06). The inner page sorts every column on the server; the
// Recent lookups card shows the same columns with plain headers and no sort (RCA-11-08), and
// without the page's minimum widths, which together are wider than the card.
export const activityColumns = ({ t, sortable = true }) => {
  const receipt = getReceiptColumns({ t })
  const column = (base, label, key = base.key) =>
    sortable
      ? { ...base, title: sortableTitle(t(label), key), sorter: true }
      : {
          ...base,
          title: t(label),
          sorter: false,
          defaultSortOrder: undefined,
          minWidth: undefined,
          ...(NO_WRAP.has(base.key) && { onCell: () => ({ style: { whiteSpace: "nowrap" } }) })
        }

  return [
    sortable ? receipt.card : column(receipt.card, "Card"),
    column(
      {
        key: "descriptor",
        dataIndex: "descriptor",
        minWidth: 180,
        render: (value) => value || "—"
      },
      "Descriptor"
    ),
    sortable ? receipt.channel : column(receipt.channel, "Channel"),
    sortable ? receipt.program : column(receipt.program, "Program"),
    column(
      {
        key: "result",
        dataIndex: "result",
        minWidth: 140,
        render: (value) => <ResultTag value={value} />
      },
      "Result"
    ),
    sortable ? receipt.amount : column(receipt.amount, "Amount"),
    column(receipt.fee_charged, "Volume charged"),
    column(receipt.date, "When")
  ]
}
